/**
 * Comprime/ridimensiona un'immagine prima dell'upload (evita 413 sui proxy).
 * SVG e file non-immagine restano invariati.
 */
export async function compressImageFile(file, options = {}) {
  if (!file || !file.type || !file.type.startsWith("image/")) return file;
  if (file.type === "image/svg+xml") return file;

  const maxWidth = options.maxWidth || 1920;
  const maxHeight = options.maxHeight || 1920;
  const quality = options.quality || 0.82;
  const maxBytes = options.maxBytes || 900 * 1024;

  if (file.size <= maxBytes && file.size <= 1024 * 1024) {
    // già sotto ~1MB: prova comunque un resize soft solo se enorme in pixel via decode
  }

  const bitmap = await createImageBitmap(file);
  try {
    let { width, height } = bitmap;
    const scale = Math.min(1, maxWidth / width, maxHeight / height);
    width = Math.max(1, Math.round(width * scale));
    height = Math.max(1, Math.round(height * scale));

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, width, height);

    const preferJpeg = file.type !== "image/png" && file.type !== "image/webp";
    const mime = preferJpeg ? "image/jpeg" : file.type === "image/webp" ? "image/webp" : "image/png";

    let blob = await canvasToBlob(canvas, mime, quality);
    let q = quality;
    while (blob && blob.size > maxBytes && q > 0.45) {
      q -= 0.1;
      blob = await canvasToBlob(canvas, mime === "image/png" ? "image/jpeg" : mime, q);
    }
    if (!blob) return file;

    const baseName = (file.name || "image").replace(/\.[^.]+$/, "");
    const ext = blob.type === "image/png" ? "png" : blob.type === "image/webp" ? "webp" : "jpg";
    return new File([blob], `${baseName}.${ext}`, { type: blob.type, lastModified: Date.now() });
  } finally {
    if (typeof bitmap.close === "function") bitmap.close();
  }
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
}
